export class ChangedVersion {
    cedula: String;
    programa: number;
    versionActual: number;
    nuevaVersion: number;
    justificacion: String;

}
